import { Button, ButtonProps, Stack } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { useRouteMatch } from '@/hooks/useRouteMatch';

export const NavigationButtonMenuable: React.FC<
  ButtonProps & {
    text: string;
    href: string;
    matchHref?: string;
    isExact?: boolean;
  }
> = ({ text, href, matchHref, isExact, children, ...props }) => {
  const isRouteMatch = useRouteMatch(matchHref ?? href, {
    isExact,
  });

  return (
    <>
      <Button
        as={NextLink}
        href={href}
        variant="ghost"
        size="lg"
        justifyContent="left"
        colorScheme="gray"
        isActive={!!children ? false : isRouteMatch}
        rounded="xl"
        color={isRouteMatch ? 'gray.800' : 'gray.600'}
        {...props}
      >
        {text}
      </Button>
      {isRouteMatch && !!children && <Stack pl="6">{children}</Stack>}
    </>
  );
};
